import React from "react";
import { ColorPicker, Tooltip } from "antd";
import { getTextWidth } from "../../services/helper/getTextWidth";
import "./index.css";

const RESULT = 'Result', HISTORY = 'History', IMPORT = 'Import', COMPARE = 'Comparison', OPTIMIZATION = 'Optimization', SWEEPMODEL = 'SweepModel',
  WAVEFORM_EXP_CHECK = "waveformExpCheck", END_TO_END = 'End-to-End', SUB_TITLE = "subTitle", VICTIM = "Victim";
/**
 *  
 * tree node title
 * //waveform -> color Usage comp-pin,curve value
 * */
function resultTreeCurveNodeTitle(nodeData, action) {
  const { color, id, value, pcb, parentKey } = nodeData || {};
  //mouse hover curve value
  const _value = action.curveMouseObj ? action.curveMouseObj[id] || "" : value;
  const currentValueWidth = _value ? getTextWidth(_value, 14, 100, "bold") + 40 : 10;
  const labelWidth = `calc(100% - ${(16 + currentValueWidth)}px)`;//16: checkbox
  const pcbColor = (action.designs || []).find(item => item.name === pcb);
  const _color = action.getCurveColor ? action.getCurveColor(nodeData) || color : color

  return <div className='result-tree-node-content'>
    <div className='result-tree-node-title'>
      <ColorPicker
        value={_color}
        className='aurora-color-picker-small'
        onChange={(value) => action.colorChange(value, id, parentKey)}
        size='small'
        onClick={(e) => action.stopPropagation(e)}
        id={`col::${id}`}
      />
      {action.customizeTitle ? <label
        htmlFor={`col::${id}`}
        style={{ maxWidth: labelWidth }}
      >{action.customizeTitle(nodeData, action)}</label>
        : nodeLabelRender({ ...nodeData, labelWidth, pcbColor })
      }
      <span className={`result-tree-curve-current ${action.resultCurveCurrentClassName || ""}`} style={{ color: _color }}>{isNaN(parseFloat(_value)) ? '' : _value}</span>
    </div>
  </div>
}

function nodeLabelRender(data) {
  const title = data.usage ? `${data.usage} - ${data.name} - ${data.pcb}` : data.name;
  if (data.usage) {
    //waveform
    return <Tooltip
      title={title}
      classNames={{ root: 'aurora-tooltip' }}
    ><label
      htmlFor={`col::${data.id}`}
      style={{ maxWidth: data.labelWidth || null }}
    >
        <span className="result-tree-node-usage">{data.usage}</span>
        <span
          style={data.pcbColor && data.pcbColor.color ? { color: data.pcbColor.color } : {}}
          className="result-tree-node-name"
        >{data.name}</span>
        {(!data.notShowPcbName && data.pcb) && <span className="result-tree-node-pcb">{data.pcb}</span>}
      </label>
    </Tooltip>
  }
  //s-parameter TDR SBR ...
  return <Tooltip
    title={title}
    classNames={{ root: 'aurora-tooltip' }}
  ><label
    htmlFor={`col::${data.id}`}
    style={{ maxWidth: data.labelWidth || null }}
  >
      <span
        style={data.pcbColor && data.pcbColor.color ? { color: data.pcbColor.color } : {}}
        className="result-tree-node-name"
      >{data.name}</span>
    </label>
  </Tooltip>
}

/* row node (signal) */
function resultTreeSignalTitle(nodeData) {
  return <div className="result-tree-row-node-content">
    {/* signal name */}
    <span className="result-tree-row-node-title"> {nodeData.title || nodeData.name || ""}</span>
  </div>
}

export {
  resultTreeCurveNodeTitle,
  resultTreeSignalTitle,
  nodeLabelRender,
  RESULT,
  HISTORY,
  IMPORT,
  COMPARE,
  OPTIMIZATION,
  SWEEPMODEL,
  WAVEFORM_EXP_CHECK,
  END_TO_END,
  SUB_TITLE,
  VICTIM
}